/// <reference types="vite-plugin-svgr/client" />
import AndroidWifi4BarAlertSymbol from '@material-symbols/svg-400/outlined/android_wifi_4_bar_alert.svg?react';
import AssignmentSymbol from '@material-symbols/svg-400/outlined/assignment.svg?react';
import ContractSymbol from '@material-symbols/svg-400/outlined/contract.svg?react';
import DeliveryTruckSpeedSymbol from '@material-symbols/svg-400/outlined/delivery_truck_speed.svg?react';
import DoneAllSymbol from '@material-symbols/svg-400/outlined/done_all.svg?react';
import FilterListSymbol from '@material-symbols/svg-400/outlined/filter_list.svg?react';
import StarSymbol from '@material-symbols/svg-400/outlined/star.svg?react';
import ThumbDownSymbol from '@material-symbols/svg-400/outlined/thumb_down.svg?react';
import ThumbUpSymbol from '@material-symbols/svg-400/outlined/thumb_up.svg?react';
import WarningSymbol from '@material-symbols/svg-400/outlined/warning.svg?react';

import { type IconGlyph } from '../types';

export const SYMBOL_ICONS = {
  active: DoneAllSymbol,
  contract: ContractSymbol,
  dataExchangeIssues: AndroidWifi4BarAlertSymbol,
  delivery: DeliveryTruckSpeedSymbol,
  favorite: StarSymbol,
  filter: FilterListSymbol,
  invoice: AssignmentSymbol,
  star: StarSymbol,
  thumbDown: ThumbDownSymbol,
  thumbUp: ThumbUpSymbol,
  warning: WarningSymbol,
} as const satisfies Record<string, IconGlyph>;
